/**
 * A React component that displays a loading spinner.
 * @component
 * @example
 * return (
 *   <Loading />
 * )
 */
import React from 'react';
import Loader from '../../assets/images/giphy.gif';
// import './loading.scss';


/**
 * A functional component that displays a loading spinner if the 'show' prop is true.
 * @param {Object} props - The component props.
 * @param {boolean} props.show - Determines whether to show the loading spinner or not.
 * @returns {JSX.Element|null} - The loading spinner component or null.
 */
const Loading = (props) => {
  const { show } = props
  return (
    show ? <div className={'full'}><img src={Loader} title="" alt="" /></div> : null)
}

export default Loading;
